import React from 'react';
import { Typography, Card, Row, Col, Space } from 'antd';
import { 
  RobotOutlined, 
  ThunderboltOutlined, 
  DatabaseOutlined, 
  LineChartOutlined,
  BookOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Tree, TreeNode } from 'react-organizational-chart';
const { Title, Paragraph, Text } = Typography;

function Home() {
  const navigate = useNavigate();

  const AgentCard = ({ title, description, icon, path }) => (
    <Card
      hoverable
      onClick={() => navigate(path)}
      style={{
        width: 300,
        textAlign: 'center',
        cursor: 'pointer',
        margin: 'auto'
      }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div style={{ fontSize: '32px', color: 'var(--theme-primary)' }}>
          {icon}
        </div>
        <div>
          <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '8px' }}>
            {title}
          </Text>
          <Text type="secondary" style={{ fontSize: '13px' }}>
            {description}
          </Text>
        </div>
      </Space>
    </Card>
  );

  return (
    <div className="welcome-container">
      <div className="agent-icon">
        <RobotOutlined style={{ fontSize: '64px', color: '#ffffff' }} />
      </div>
      
      <Title level={3} style={{ color: 'var(--theme-primary)', marginTop: '24px', marginBottom: '8px' }}>
        Hello! 👋
      </Title>
      
      <Text style={{ fontSize: '16px', color: '#8c8c8c', marginBottom: '40px' }}>
        Who do you want to chat with?
      </Text>

      <div style={{ marginTop: '40px' }}>
        <Tree
          lineWidth={'2px'}
          lineColor={'var(--theme-primary)'}
          lineBorderRadius={'10px'}
          nodePadding={'25px'}
          label={
            <AgentCard
              title="Manager Agent"
              description="Ask anything — it figures out the best way to answer by coordinating Data and Knowledge together."
              icon={<ThunderboltOutlined />}
              path="/manager/chat"
            />
          }
        >
          <TreeNode
            label={
              <AgentCard
                title="Data Agent"
                description="Ask questions about your interested data and get instant answers, tables, queries, and charts."
                icon={<DatabaseOutlined />}
                path="/data/chat"
              />
            }
          />
          <TreeNode
            label={
              <AgentCard
                title="Knowledge Agent"
                description="Find answers from engineering documents, guides, and reference materials quickly."
                icon={<BookOutlined />}
                path="/knowledge/chat"
              />
            }
          />
        </Tree>
      </div>
    </div>
  );
}

export default Home;
